module.exports = __webpack_public_path__ + "img/1F1FC-1F1EB.160d488c.svg";